import React, { useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Typography,
  Tooltip,
  useTheme,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const ExceptionActionMenu = ({
  disabled = false,
  disabledTooltip = "",
  onMark,
  markDisabled = false,
  markDescription = "Create exception for selected items",
  onDelete,
  deleteDisabled = false,
  deleteCount = 0,
  deleteDescription = "Remove existing exception(s)",
}) => {
  const theme = useTheme();
  const [menuAnchor, setMenuAnchor] = useState(null);

  const handleMenuOpen = (event) => setMenuAnchor(event.currentTarget);
  const handleMenuClose = () => setMenuAnchor(null);

  const handleMark = () => {
    handleMenuClose();
    onMark?.();
  };

  const handleDelete = () => {
    handleMenuClose();
    onDelete?.();
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Tooltip title={disabled ? disabledTooltip : ""} arrow placement="top">
        <span>
          <Button
            variant="contained"
            endIcon={<ArrowDropDownIcon sx={{ fontSize: 18 }} />}
            onClick={handleMenuOpen}
            disabled={disabled}
            sx={{
              bgcolor: theme.customColors.button.primary,
              color: theme.customColors.button.text,
              fontWeight: 500,
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "14px",
              px: 2,
              py: 1,
              minWidth: 160,
              whiteSpace: "nowrap",
              "&:hover": { bgcolor: theme.palette._blue.dark },
              "&:disabled": {
                bgcolor: theme.customColors.background.light,
                color: theme.customColors.text.disabled,
              },
            }}
          >
            Manage Exception
          </Button>
        </span>
      </Tooltip>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 260,
            boxShadow:
              "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
          },
        }}
      >
        <MenuItem
          onClick={handleMark}
          disabled={markDisabled}
          sx={{
            py: 1.5,
            px: 2,
            "&:hover": { backgroundColor: "#F3F4F6" },
          }}
        >
          <Box>
            <Typography
              variant="body2"
              fontWeight={600}
              color={theme.customColors.text.strong}
            >
              Mark Exception
            </Typography>
            <Typography
              variant="caption"
              color={theme.customColors.text.secondary}
              sx={{ display: "block", mt: 0.25 }}
            >
              {markDescription}
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={handleDelete}
          disabled={deleteDisabled}
          sx={{
            py: 1.5,
            px: 2,
            "&:hover": { backgroundColor: "#F3F4F6" },
          }}
        >
          <Box>
            <Typography
              variant="body2"
              fontWeight={600}
              className="delete-title"
              color={theme.customColors.text.strong}
            >
              Delete Exception
              {deleteCount > 1 ? "s" : ""}
              {deleteCount > 0 ? ` (${deleteCount})` : ""}
            </Typography>
            <Typography
              variant="caption"
              className="delete-subtitle"
              color={theme.customColors.text.secondary}
              sx={{ display: "block", mt: 0.25 }}
            >
              {deleteDescription}
            </Typography>
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ExceptionActionMenu;
